import { isEmpty, memoize, join } from "lodash";

interface Meta {
  submitFailed?: boolean;
  dirty?: boolean;
  error?: string;
  invalid?: boolean;
  touched?: boolean;
  valid?: boolean;
  active?: boolean;
  initial?: any;
  form?: string;
}

interface RestProps {
  id?: string;
}

interface Input {
  name?: string;
}

export const returnFieldState = (meta: Meta = {}): {
  isInvalid: boolean;
  isValid: boolean;
} => {
  const {
    submitFailed = false,
    dirty = false,
    error = "",
    invalid = false,
    touched = false,
    valid = false
  } = meta;

  const isInvalid = (
    submitFailed || touched
  ) &&
    !!(error || invalid);

  const isValid = (dirty || touched) && !!(valid || !error);

  return {
    isInvalid: !!isInvalid,
    isValid: !!isValid
  };
};

export const returnHasValueOrFocused = (value: any, meta: Meta = {}): boolean => {
  const {
    active = false,
    initial = null,
    dirty = false
  } = meta;

  if (value) return true;
  return !isEmpty(value) ||
    active ||
    (isEmpty(initial) && dirty);
};

const generateIdFn = (prefix: string, formName?: string, id?: string, name?: string, ...suffixes: string[]): string => {
  return (
    [
      prefix,
      formName,
      (id || name),
      ...suffixes
    ].filter(Boolean)
      .join("-")
  );
};

const generateIdMemoized = memoize(
  generateIdFn,
  (...args: any[]) => {
    return join(args);
  }
);

export const generateFieldId = (
  prefix: string,
  meta: Meta = {},
  restProps: RestProps = {},
  input: Input = {},
  ...suffixes: string[]
): string => {
  return generateIdMemoized(prefix, meta.form, restProps.id, input.name, ...suffixes);
};

